import {
  ACTION_BAR_SET_SELECTED_OUTLET_IDS,
  ACTION_BAR_SET_OUTLETS,
} from './constants';

/**
 *
 * @param {Array} selectedOutletIds array of outlet id
 * @return {{type, payload: {selectedOutletIds: *}}}
 */
export function setSelectedOutletIds(selectedOutletIds) {
  return {
    type: ACTION_BAR_SET_SELECTED_OUTLET_IDS,
    payload: { selectedOutletIds },
  };
}

/**
 *
 * @param {Array} outlets array of outlets
 * @return {{type, payload: {outlets: *}}}
 */
export function setOutlets(outlets) {
  return { type: ACTION_BAR_SET_OUTLETS, payload: { outlets } };
}
